import { Component, OnInit, DoCheck } from '@angular/core';
import { AuthenticationService } from '@app/services/authentication.service';
import { Router } from '@angular/router';
import { SessionService } from '@app/services/session.service';

@Component({
    template: ''
  })
  
  export class LogoutComponent implements OnInit {
  
    constructor(
        private authService: AuthenticationService,
        private session: SessionService,
        private router: Router,
    ) {}
  
    ngOnInit() {
      console.log('logout');
      this.authService.logout();
      this.session.closeSession();
      this.router.navigate(['login']);
    }
  
  }